import { trim } from "lodash";
import { isEmail } from "components/utils/validation";

// Guests sign in with an email address and have no first or last name, so their messages come with a blank user name or the email.
export const isGuestSender = (userName?: string) => trim(userName) === "" || isEmail(trim(userName));

export const getSenderName = (userName?: string) => {
    const name = trim(userName);

    if (!isGuestSender(name)) {
        return name;
    }

    return name ? `Guest user (${name})` : "Guest user";
};

// A guest has no name, and their own messages come back with a blank user name or their email.
export const isCurrentUserSender = (
    userName: string | undefined,
    user: { firstName?: string; lastName?: string; email?: string; isGuest?: boolean }
) => {
    const name = trim(userName);
    const currentUserName = trim([user.firstName, user.lastName].join(" "));

    if (user.isGuest && name !== "" && name.toLowerCase() === trim(user.email).toLowerCase()) {
        return true;
    }

    return name === currentUserName && (currentUserName !== "" || Boolean(user.isGuest));
};
